/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var O;!function(O){O[O.TUMBLE=0]="TUMBLE",O[O.LOOK_AROUND=1]="LOOK_AROUND"}(O||(O={}));export{O as TiltMode};
